import Articles from "../../components/LKG/English/Articles";
import OneMany from "../../components/LKG/English/OneMany";
import OppositeWords from "../../components/LKG/English/OppositeWords";
import PhoneticWords from "../../components/LKG/English/PhoneticWords";
import PictureComposition from "../../components/LKG/English/PictureComposition";
import RhymingWords from "../../components/LKG/English/RhymingWords";
import VowelConsonant from "../../components/LKG/English/VowelConsonant";
import ThisThatTheseThose from "../../components/LKG/English/ThisThatTheseThose";

import ArticlesMenu from "./Articles";
import PhoneticWordsMenu from "./PhoneticWords";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/lkg/english-language/phonetic-words", title: "Phonetic Words", component: PhoneticWords, subMenu: PhoneticWordsMenu},
    { url: "/lkg/english-language/articles", title: "Articles", component: Articles, subMenu: ArticlesMenu},
    { url: "/lkg/english-language/one-and-many", title: "One and Many", component: OneMany},
    { url: "/lkg/english-language/rhyming-words", title: "Rhyming Words", component: RhymingWords},
    { url: "/lkg/english-language/vowels-and-consonants", title: "Vowels and Consonants", component: VowelConsonant},
    { url: "/lkg/english-language/this-that-these-those", title: "This–That & These–Those", component: ThisThatTheseThose},
    { url: "/lkg/english-language/picture-composition", title: "Picture Composition", component: PictureComposition},
    { url: "/lkg/english-language/opposites", title: "Opposites", component: OppositeWords},
];


export default topics;